export const showTreeStatus = (status) => {
  let tree_status = '';
  status===1 ? tree_status = 'Healthy' :
  status===2 ? tree_status = 'Abnormal':
  status===3 ? tree_status = 'Unpaired':
  tree_status = 'Empty';
  return tree_status;
};
